import { randomId } from '@mui/x-data-grid-generator';

/** Object info of trade partner page's new and edit dialog. */
export const tradePartnerConfig = [
    {
        field: 'partner_type',
        name: 'Type',
        inputType: 'singleSelect',
        required: true,
        editable: true,
        mode: ['new', 'edit'],
    },
    {
        field: 'fullname',
        name: 'Full Name',
        inputType: 'textField',
        required: true,
        editable: true,
        mode: ['new', 'edit'],
    },
    {
        field: 'name',
        name: 'Name',
        inputType: 'textField',
        required: true,
        editable: true,
        mode: ['new', 'edit'],
    },
    {
        field: 'address_one',
        name: 'Address',
        inputType: 'textFieldArea',
        required: true,
        editable: true,
        mode: ['new', 'edit'],
    },
    {
        field: 'code',
        name: 'Code',
        inputType: 'textField',
        required: false,
        editable: true,
        mode: ['new', 'edit'],
    },
    {
        field: 'iata_firms',
        name: 'IATA(Firms)',
        inputType: 'textField',
        required: false,
        editable: true,
        mode: ['new', 'edit'],
    },
    {
        field: 'contact',
        name: 'Contact Person',
        inputType: 'textField',
        required: false,
        editable: true,
        mode: ['new', 'edit'],
    },
    {
        field: 'phone',
        name: 'Phone',
        inputType: 'textField',
        required: false,
        editable: true,
        mode: ['new', 'edit'],
    },
    {
        field: 'ein',
        name: 'EIN',
        inputType: 'textField',
        required: false,
        editable: true,
        mode: ['new', 'edit'],
    },
    {
        field: 'website',
        name: 'Website Link',
        inputType: 'textField',
        required: false,
        editable: true,
        mode: ['new', 'edit'],
    },
    {
        field: 'ocean_carrier',
        name: 'Ocean Carrier',
        inputType: 'multiSelect',
        required: false,
        editable: false,
        mode: ['edit'],
    },
    {
        field: 'remark',
        name: 'Remark',
        inputType: 'textFieldArea',
        maxLength: 255,
        required: false,
        editable: true,
        mode: ['new', 'edit'],
    },
];

/** Select input's option. */
export const newTradePartnerType = [
    { id: 1, content: 'Client' },
    { id: 2, content: 'Shipper/Consignee' },
    { id: 3, content: 'Forwarder' },
    { id: 4, content: 'Trucker' },
];

/** Initial state of tradePartnerData. */
export const initTradePartnerData = {
    id: randomId(),
    partner_type: 'Client',
    fullname: '',
    name: '',
    address_one: '',
    code: '',
    iata_firms: '',
    contact: '',
    website: '',
    phone: '',
    ein: '',
    remark: '',
    status: true,
};

export const initTradePartnerValidator = {
    partner_type: false,
    fullname: false,
    name: false,
    address_one: false,
    iata_firms: false,
};

/** Initial value for selectedNote state. */
export const initNote = {
    index: 0,
    content: '',
    progress: { value: 'pre_alert', label: 'Pre Alert' },
};

export const initApplySetting = {
    /** State for rendering selected preset's setting value. */
    renderValue: {},
    /** State for managing the input value for the new preset name. */
    presetName: '',
    /** State for managing selected note. */
    selectedNote: initNote,
    /** State for presenting the current mode. */
    mode: 'view',
    /** State for temporally saving initial editing value. */
    initEditValue: {},
};
